import React from 'react';
import { Query } from 'react-apollo';
import Alert from '@material-ui/lab/Alert';
import { GET_ELEMENT_TOKEN } from 'graphql/calendar';
import Spin from 'components/common/Spin';

class CronofyEl extends React.Component {
  componentDidMount() {
    const scheduler = window.CronofyElements.AvailabilityRules({
      target_id: 'cronofy-element',
      element_token: this.props.token,
      availability_rule_id: 'weadmit_hours',
      tzid: this.props.timezone,
      config: {
        week_start_day: 'monday',
        start_time: '07:00',
        end_time: '23:00',
        duration: 30,
      },
      styles: {
        colors: {
          // available: "#84de8a",
          // unavailable: "#f57d7d",
          primary: '#1278FB',
        },
        prefix: 'custom-name',
      },
      callback: (e) => {
        console.log(e);
      },
    });

    this.scheduler = scheduler;
  }
  shouldComponentUpdate(nextProps, nextState, nextContext) {
    if (nextProps.timezone !== this.props.timezone) {
      console.log('updating timezone to- ', nextProps.timezone);
      this.scheduler.update({ tzid: nextProps.timezone });
    }
    return false;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.timezone !== this.props.timezone) {
      console.log('updating timezone to- ', this.props.timezone);
      this.scheduler.update({ tzid: this.props.timezone });
    }
  }

  render() {
    return <div id="cronofy-element" />;
  }
}

class CronofyUI extends React.Component {
  render() {
    return (
      <Query query={GET_ELEMENT_TOKEN}>
        {({ data, loading, error }) => {
          if (loading) return <Spin spinning linear />;
          if (error) return <Alert color={'error'}>{error.message}</Alert>;

          const token = data?.calendar_accounts_token.token;

          return (
            <div>
              <CronofyEl token={token} timezone={this.props.timezone} />
            </div>
          );
        }}
      </Query>
    );
  }
}

export default CronofyUI;
